<script>
import { management } from "@/api";
import { startHourOptions } from "@/common/constants/startHourHelpers.js";

export default {
  props: {
    mustSaveOnChange: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      startHourOptions,
      startHour: null,
      formattedStartHour: "...",
    }
  },
  async created() {
    const startHour = (await management.getManagementConfigs())[0].IRRIGATION_INITIAL_HOUR;
    this.startHour = Number(startHour);
    this.setFormmatedStartHour();
  },
  methods: {
    setFormmatedStartHour() {
      this.formattedStartHour = this.startHourOptions.find(opt => opt.value === Number(this.startHour)).text;
    }
  },
  watch: {
    startHour: {
      async handler(newValue, oldValue) {
        try {
          if(this.mustSaveOnChange && oldValue !== null) {
            (await management.postManagementConfigs({IRRIGATION_INITIAL_HOUR: newValue}));
            
            this.setFormmatedStartHour();
            alert(`Sucesso ao salvar hora inicial do ciclo diário de irrigação como "${this.formattedStartHour}".`, "s");
          }

          this.$emit("input", newValue);

        } catch(e) {
          console.error(e);

          alert("Erro ao salvar hora inicial do ciclo diário de irrigação.", "e")

        }
      }
    }
  },
}
</script>